export default __webpack_public_path__ + "static/media/tuzla-kart-nereden-alabilirim.675fa10e.JPG";